import styled from 'styled-components';

const MetricConfigWrapper = styled.div`
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #d7d7d7;
  margin-bottom: 20px;
  .value_selector__control {
    border-bottom: none !important;
  }

  .configCard {
    background: #ffffff;
    border: 1px solid #ebebeb;
    border-radius: 5px;
    padding: 20px;
    .ruleGroup {
      width: fit-content;
    }
    [id='rule.value'] {
      width: max-content;
    }
  }
  .conditionCard {
    min-height: 130px;
  }
`;

export { MetricConfigWrapper };
